export default __webpack_public_path__ + "static/media/grayMediumTank.40bfcbaa.svg";